import { render, staticRenderFns } from "./PDFDISPLAY.vue?vue&type=template&id=30c484ce&scoped=true&"
import script from "./PDFDISPLAY.vue?vue&type=script&lang=js&"
export * from "./PDFDISPLAY.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c484ce",
  null
  
)

export default component.exports